import { isGenericContactRole } from "@shared/contactRole";

interface ContactCompanyFields {
  companyId?: number | null;
  companyName?: string | null;
  role?: string | null;
  areasOfActivity?: Array<{
    id?: number | null;
    companyId?: number | null;
    companyName?: string | null;
    role?: string | null;
    isPrimary?: boolean | null;
  }> | null;
}

export interface PrimaryContactCompany {
  id: number | null;
  associationId: number | null;
  name: string;
  role: string;
}

/** Un'unica scelta della relazione corrente per testata, drawer e azioni. */
export function resolvePrimaryContactCompany(
  contact: ContactCompanyFields,
  lookupCompanyName?: (companyId: number) => string | null,
): PrimaryContactCompany | null {
  const directId = contact.companyId ?? null;
  const directName = contact.companyName?.trim() || (directId ? lookupCompanyName?.(directId) : null);
  const areas = Array.isArray(contact.areasOfActivity)
    ? contact.areasOfActivity.filter(area => area && (area.companyId || area.companyName?.trim()))
    : [];
  // contacts.companyId è la fonte canonica dell'azienda corrente. Una
  // relazione secondaria o non sincronizzata non deve sovrascriverlo in UI.
  const area = directId
    ? areas.find(item => item.isPrimary && Number(item.companyId) === Number(directId))
      || areas.find(item => Number(item.companyId) === Number(directId))
    : areas.find(item => item.isPrimary) || areas[0];

  if (area) {
    const areaId = area.companyId ?? null;
    const areaName = area.companyName?.trim()
      || (areaId ? lookupCompanyName?.(areaId) : null)
      || (areaId === directId ? directName : null);
    return {
      id: areaId,
      associationId: area.id ?? null,
      name: areaName || "Azienda da verificare",
      role: (!isGenericContactRole(area.role) ? area.role : contact.role || area.role || "") || "",
    };
  }

  if (!directId && !directName) return null;
  return {
    id: directId,
    associationId: null,
    name: directName || "Azienda da verificare",
    role: contact.role || "",
  };
}
